export default {
  setBasicData: (state, data) => {
    state.basic = data;
    state.permissions = data.permissions;
  },
  setFullData: (state, data) => {
    state.full = data;
  },
};
